import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet, Image, ActionSheetIOS, Platform, Dimensions } from 'react-native';
import { LinearGradient } from 'expo-linear-gradient';
import { FontAwesome5, FontAwesome } from '@expo/vector-icons';
import CS from '../../constants/Styles';
import Colors from '../../constants/Colors';
import Images from '../../constants/Images';
import { addressToolTip, projectGalleryToolTip } from '../../constants/Arrays';
import { Loader, Button, BackgroundGradient, TextInputContainer, AddressPicker, LocationPicker, Validate, Tag, PhotosDocumentsAddPreviewGrid, SafeAreaView, YesNoToggle, Alert, ToolTipWrapper } from '../../components';
import * as ImagePicker from 'expo-image-picker';
import Constants from 'expo-constants';
import { formatPhoneNumber, manipulateImage, dataUrlToFile, isImageExtensionValid } from '../../utils/Functions';
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view';
import Insurance from './Insurance';
import { useLinkTo } from '@react-navigation/native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

const CompanyProfileScreen = ({ navigation, ...props }) => {
  const [loading, setLoading] = React.useState(false);
  const [scrollEnabled, setScrollEnabled] = React.useState(true);
  const [alertOptions, setAlertOptions] = React.useState({});
  // const [newServiceArea, setNewServiceArea] = React.useState('');
  // const [newSkill, setNewSkill] = React.useState('');
  const [initialLocation, setInitialLocation] = React.useState('');

  // const [expiryDate, setExpiryDate] = React.useState('date');

  // const [showExpiry, setShowExpiry] = React.useState(false);
  const linkTo = useLinkTo();
  const insets = useSafeAreaInsets();

  const defaultLogo = require('../../assets/img/blank_company_logo.jpg');

  const defaultIsInvalid = {
    companyName: false,
    bio: false,
    emailAddress: false,
    phoneNumber: false,
    address: false,
    website: false,
    insuranceIssuer: false,
    insurancePolicy: false,
    insuranceExpiry: false,
    license: false,
    newServiceArea: false,
    // newSkill: false
  };
  const [isInvalid, setIsInvalid] = React.useState(defaultIsInvalid);

  let textInputs = {
    companyName: React.useRef(null),
    bio: React.useRef(null),
    emailAddress: React.useRef(null),
    phoneNumber: React.useRef(null),
    address: React.useRef(null),
    website: React.useRef(null),
    insuranceIssuer: React.useRef(null),
    insurancePolicy: React.useRef(null),
    insuranceExpiry: React.useRef(null),
    license: React.useRef(null),
    newServiceArea: React.useRef(null),
    // newSkill: React.useRef(null),
  };

  let scrollRef = React.useRef(null);
  // let locCity = '';
  // let locProv = '';
  // let locationInitialSearch = ''

  // React.useEffect(() => {
  //   props.setContractorAddress(props.legalAddress);
  //   props.setContractorStreetNumber(props.legalAddressNumber);
  //   props.setContractorAddressUnit(props.legalAddressUnit);
  //   props.setContractorStreetId(props.legalStreetId);
  // }, []);

  React.useEffect(() => {
    if(props.contractorAddress){
      console.log('address set: ', props.contractorAddress);
      setInitialLocation(props.contractorAddress.substr(props.contractorAddress.lastIndexOf('.') + 1).trim());
      console.log('locationInitialSearch: ', props.contractorAddress.substr(props.contractorAddress.lastIndexOf('.') + 1).trim());
      // let loc = locationInitialSearch.split(', ');
      // console.log('city: ', loc[0]);
      // console.log('prov: ', loc[1]);
      // locCity = loc[0];
      // locProv = loc[1];
    }else{
      setInitialLocation('');
    }
  }, [props.contractorAddress])

  React.useEffect(() => {
    checkSignUpProgress();
  }, []);

  const checkSignUpProgress = (route) => {
    if (props.structure === 'Individual'){
      if (!props.signUpProgress.AccountType) {
        linkTo('/login');
      }
    }else{
      if (!props.signUpProgress.VerifyBusiness) {
        linkTo('/login');
      }
    }
  }

  const checkCompanyProfile = async () => {
    // setAlertOptions({ visible: true, title: 'Error', message: 'Sorry, we need camera roll permissions to make this work!', });
    // return;
    // companyName
    if (!Validate.Name(props.companyName)) {
      setIsInvalid(prevState => { return { ...prevState, companyName: true } });
      textInputs.companyName.current.focus();
      return;
    }
    setIsInvalid(prevState => { return { ...prevState, companyName: false } });

    // bio
    // if (!Validate.Name(props.bio)) {
    //   setIsInvalid(prevState => { return { ...prevState, bio: true } });
    //   textInputs.bio.current.focus();
    //   return;
    // }
    // setIsInvalid(prevState => { return { ...prevState, bio: false } });

    // phoneNumber
    // if (!Validate.PhoneNumber(props.contractorPhoneNumber)) {
    //   setIsInvalid(prevState => { return { ...prevState, phoneNumber: true } });
    //   textInputs.phoneNumber.current.focus();
    //   return;
    // }
    // setIsInvalid(prevState => { return { ...prevState, phoneNumber: false } });

    // address
    // console.log('test', props.contractorStreetId);
    // if (!props.contractorStreetId) {
    //   setIsInvalid(prevState => { return { ...prevState, address: true } });
    //   textInputs.address.current.focus();
    //   return;
    // }
    // setIsInvalid(prevState => { return { ...prevState, address: false } });

    // website
    // if (!Validate.Url(props.website)) {
    //   setIsInvalid(prevState => { return { ...prevState, website: true } });
    //   textInputs.website.current.focus();
    //   return;
    // }
    // setIsInvalid(prevState => { return { ...prevState, website: false } });

    // service areas
    // if(props.serviceAreas.length === 0){
    //   Alert.alert('Error', 'You must add at least 1 service area');
    //   setIsInvalid(prevState => { return { ...prevState, newServiceArea: true } });
    //   textInputs.newServiceArea.current.focus();
    //   return;
    // }

    // skills
    // if (props.skills.length === 0) {
    //   Alert.alert('Error', 'You must add at least 1 skill');
    //   setIsInvalid(prevState => { return { ...prevState, newSkill: true } });
    //   textInputs.newSkill.current.focus();
    //   return;
    // }
    
    props.completeStep('CompanyProfile');
  };

  const onChangeCompanyName = (input) => {
    if (isInvalid.companyName && Validate.Name(input)) {
      setIsInvalid(prevState => { return { ...prevState, companyName: false } });
    }
    props.setCompanyName(input);
  };
  const onChangeBio = (input) => {
    if (isInvalid.bio && Validate.Name(input)) {
      setIsInvalid(prevState => { return { ...prevState, bio: false } });
    }
    props.setBio(input);
  };
  const onChangeEmailAddress = (input) => {
    if (isInvalid.emailAddress && Validate.Email(input)) {
      setIsInvalid(prevState => { return { ...prevState, emailAddress: false } });
    }
    props.setContractorEmailAddress(input);
  };
  const onChangePhoneNumber = (input) => {
    input = formatPhoneNumber(input);
    if (isInvalid.phoneNumber && Validate.PhoneNumber(input)) {
      setIsInvalid(prevState => { return { ...prevState, phoneNumber: false } });
    }
    props.setContractorPhoneNumber(input);
  };
  const setIsInvalidAddress = () => {
    setIsInvalid(prevState => { return { ...prevState, address: false } });
  };
  const setIsInvalidServiceArea = () => {
    setIsInvalid(prevState => { return { ...prevState, newServiceArea: false } });
  }
  const onChangeWebsite = (input) => {
    if (isInvalid.website && Validate.Url(input)) {
      setIsInvalid(prevState => { return { ...prevState, website: false } });
    }
    props.setWebsite(input.trim());
  };
  const onChangeInsuranceIssuer = (input) => {
    if (isInvalid.insuranceIssuer && Validate.Blank(input)) {
      setIsInvalid(prevState => { return { ...prevState, insuranceIssuer: false } });
    }
    props.setInsuranceIssuer(input);
  };
  const onChangeInsurancePolicy = (input) => {
    if (isInvalid.insurancePolicy && Validate.Blank(input)) {
      setIsInvalid(prevState => { return { ...prevState, insurancePolicy: false } });
    }
    props.setInsurancePolicy(input);
  };
  const onChangeInsuranceExpiry = (event, selectedDate) => {
    console.log('onChangeInsuranceExpiry', selectedDate);
    // if (isInvalid.insuranceExpiry && Validate.Blank(input)) {
    //   setIsInvalid(prevState => { return { ...prevState, insuranceExpiry: false } });
    // }
    // props.setInsuranceExpiry(input);
    const currentDate = selectedDate || props.expiry;
    // setShowExpiry(Platform.OS === 'ios');
    props.setInsuranceExpiry(currentDate);
    // setExpiryDate(currentDate);
  };
  // const onChangeLicense = (input) => {
  //   if (isInvalid.license && Validate.Blank(input)) {
  //     setIsInvalid(prevState => { return { ...prevState, license: false } });
  //   }
  //   props.setLicense(input);
  // };

  const chooseLogo = async () => {
    // if (Platform.OS !== 'web') {
      const { status } = await ImagePicker.requestMediaLibraryPermissionsAsync();
      if (status !== 'granted') {
        setAlertOptions({ visible: true, title: 'Error', message: 'Sorry, we need camera roll permissions to make this work!', });
      } else {
        let result = await ImagePicker.launchImageLibraryAsync({
          mediaTypes: ImagePicker.MediaTypeOptions.Images,
          allowsEditing: true,
          aspect: [Images.company.logo.width, Images.company.logo.height],
          quality: 1,
        });

        console.log(result);

        // if (Platform.OS === 'web') {
        //   result.file = await dataUrlToFile(result.uri);
        // }

        // if (!result.cancelled) {
        //   let manipResult = await manipulateImage(result, Images.company.logo.width, Images.company.logo.height);
        //   props.setLogo(manipResult);
        // }
        if (!result.canceled) {
          let manipResult = await manipulateImage(result.assets[0], Images.company.logo.width, Images.company.logo.height);
          if (Platform.OS === 'web') {
            manipResult.file = await dataUrlToFile(manipResult.uri);
          }

          const isValidExtension = isImageExtensionValid(Platform.OS === 'web' ? manipResult.file.name : manipResult.uri);
          if (!isValidExtension.result) {
            setAlertOptions({ visible: true, title: 'Error', message: `Invalid image type. Images must end in one of the following extensions: ${isValidExtension.extensions}`, });
            return;
          }

          if (!manipResult.cancelled) {
            props.setLogo(manipResult);
          }
        }
      }
    // }
  }

  const removeServiceArea = (s) => {
    console.log('removeServiceArea ', s, props.serviceAreas);
    props.setServiceAreas(prevState => {
      return prevState.filter(p => {
        return p.id !== s;
      });
    });
  };
  const afterSelectLocation = () => {
    console.log('afterSelectLocation');
    setTimeout(() => {
      // scrollRef.current.scrollToEnd({ animated: false });
      setScrollEnabled(true);
    }, 250); 
    
  }
  // const verifySkill = (s) => {
  //   return !props.skills.includes(s);
  // }
  // const addSkill = () => {
  //   let newSkills = newSkill.split(',').filter((s) => {
  //     return verifySkill(s);
  //   }).map((s) => {
  //     return String(s).trim();
  //   });
  //   props.setSkills([...props.skills, ...newSkills]);
  //   setNewSkill('');
  // }
  // const removeSkill = (s) => {
  //   props.setSkills(prevState => {
  //     return prevState.filter(p => {
  //       return p !== s;
  //     });
  //   });
  // };

  const goBack = () => {
    if (navigation.canGoBack()) {
      navigation.goBack();
    } else {
      linkTo('/signup/verifybusiness');
    }
  }

  const webLogoStyle = () => {
    if(Platform.OS === 'web'){
      const screenWidth = Dimensions.get('window').width;
      return {
        width: '100%',
        maxWidth: 768,
        height: screenWidth >= 768 ? 768 * 0.5625 : screenWidth * 0.5625,
      }
    }
    return {
      aspectRatio: 960 / 540,
    }
  }

  return (
    <View style={CS.flex}>
      <BackgroundGradient />
      <Loader animating={loading} />
      <Alert options={alertOptions} setOptions={setAlertOptions} />
      <KeyboardAwareScrollView keyboardShouldPersistTaps='handled' ref={scrollRef} enableAutomaticScroll={scrollEnabled} style={styles.container} contentContainerStyle={styles.innerContainer}>
        {/* <TouchableOpacity onPress={goBack} style={{ position: 'absolute', top: 0, left: 0, width: '100%', marginVertical: 20, justifyContent: 'center' }}>
          <FontAwesome5 name="arrow-left" size={24} color="white" />
        </TouchableOpacity> */}
        {/* <View style={styles.container}> */}
        <View style={styles.logoContainer}>
          {!props.logo && 
            // <Image source={{ uri: 'https://dev.renovationtrust.com/img/contractors/new_project.jpg' }} style={[CS.responsiveImage, styles.logo]} />
            <Image source={defaultLogo} style={[CS.responsiveImage, styles.logo, webLogoStyle()]} />
          }
          {props.logo &&
            <Image source={{ uri: props.logo.uri }} style={[CS.responsiveImage, styles.logo, webLogoStyle()]} />
          }
          <LinearGradient colors={[Colors.transparentGrey3, Colors.transparentGrey, Colors.transparentGrey3]} style={styles.gradient} />
        </View>
        <View style={[styles.buttonsOverlay, { paddingTop: insets.top ? insets.top : 15 }]}>
          <TouchableOpacity onPress={goBack} hitSlop={{ top: 10, bottom: 10, left: 10, right: 10 }} style={styles.backArrow}>
            <FontAwesome5 name="arrow-left" size={24} color="white" />
          </TouchableOpacity>
          <Text style={[CS.mediumTitle, CS.whiteText, CS.centerText, styles.pageTitle]}>Public Company Profile</Text>
          <TouchableOpacity onPress={chooseLogo} hitSlop={{ top: 10, bottom: 10, left: 10, right: 10 }} style={styles.editButton}>
            <FontAwesome name="image" size={32} color="white" />
          </TouchableOpacity>
        </View>
        {/* company name */}
        <View style={[styles.marginContainer, { marginTop: 10 }]}>
          <Text style={[CS.smallText, CS.lightBlueText, styles.inputLabel]}>Operating Name</Text>
          <TextInputContainer
            placeholder='Operating Name'
            onChangeText={(t) => onChangeCompanyName(t)}
            inputRef={textInputs.companyName}
            isInvalid={isInvalid.companyName}
            spellCheck={false}
            onSubmitEditing={() => textInputs.bio.current.focus()}
            returnKeyType='next'
            // autoCorrect={false}
            textContentType='organizationName'
            autoCapitalize='words'
            value={props.companyName}
          />
        </View>
        {/* bio */}
        <View style={styles.marginContainer}>
          <Text style={[CS.smallText, CS.lightBlueText, styles.inputLabel]}>Bio</Text>
          <TextInputContainer
            placeholder='Tell us about your company and what you do'
            onChangeText={(t) => onChangeBio(t)}
            inputRef={textInputs.bio}
            isInvalid={isInvalid.bio}
            returnKeyLabel='done'
            value={props.bio}
            inputStyle={styles.bio}
            multiline={true}
            numberOfLines={6}
            autoCorrect={false}
            spellCheck={true}
          />
        </View>

        {/* project gallery */}
        <View style={[styles.marginContainer, CS.rowContainer, styles.title]}>
          <Text style={[CS.smallTitle, CS.lightText]}>Project Gallery</Text>
          <ToolTipWrapper
            text={projectGalleryToolTip}
          />
        </View>
        <View style={styles.marginContainer}>
          <PhotosDocumentsAddPreviewGrid
            items={props.projectGallery}
            setItems={props.setProjectGallery}
            delete={true}
            showAdd={true}
          />
        </View>
        
        <View style={styles.marginContainer}>
          <Text style={[CS.smallTitle, CS.lightText, styles.title]}>Contact</Text>
        </View>
        {/* company email */}
        <View style={styles.marginContainer}>
          <Text style={[CS.smallText, CS.lightBlueText, styles.inputLabel]}>Company Email</Text>
          <TextInputContainer
            placeholder='Email Address'
            textContentType='emailAddress'
            onChangeText={(t) => onChangeEmailAddress(t)}
            inputRef={textInputs.emailAddress}
            keyboardType='email-address'
            isInvalid={isInvalid.emailAddress}
            autoCapitalize='none'
            autoCompleteType='email'
            autoCorrect={false}
            returnKeyType='next'
            onSubmitEditing={() => textInputs.phoneNumber.current.focus()}
            value={props.contractorEmailAddress}
          />
        </View>
        {/* phone number */}
        <View style={styles.marginContainer}>
          <Text style={[CS.smallText, CS.lightBlueText, styles.inputLabel]}>Phone Number</Text>
          <TextInputContainer
            placeholder='Main Phone Number'
            onChangeText={(t) => onChangePhoneNumber(t)}
            inputRef={textInputs.phoneNumber}
            isInvalid={isInvalid.phoneNumber}
            spellCheck={false}
            textContentType='telephoneNumber'
            autoCompleteType='tel'
            keyboardType='phone-pad'
            onSubmitEditing={() => textInputs.address.current.focus()}
            returnKeyType='done'
            value={props.contractorPhoneNumber}
          />
        </View>
        {/* address */}
        <View style={[styles.marginContainer, CS.rowContainer, styles.inputLabel]}>
          <Text style={[CS.smallText, CS.lightBlueText]}>Address</Text>
          <ToolTipWrapper
            text={addressToolTip}
          />
        </View>
        <AddressPicker
          placeholder='100-45 Main Street. Toronto, ON'
          value={props.contractorAddress}
          address={props.contractorAddress}
          setAddress={props.setContractorAddress}
          setStreetId={props.setContractorStreetId}
          setStreetNumber={props.setContractorStreetNumber}
          setAddressUnit={props.setContractorAddressUnit}
          setZipCode={props.setContractorZipCode}
          setCountry={props.setContractorCountry}
          offsetTop={Constants.statusBarHeight}
          outerInputContainerStyle={styles.marginContainer}
          inputRef={textInputs.address}
          setIsInvalid={setIsInvalidAddress}
          scrollRef={scrollRef}
          afterSelectLocation={afterSelectLocation}
          setScrollEnabled={setScrollEnabled}
        />
        {/* website */}
        <View style={styles.marginContainer}>
          <Text style={[CS.smallText, CS.lightBlueText, styles.inputLabel]}>Website</Text>
          <TextInputContainer
            placeholder='Website'
            onChangeText={(t) => onChangeWebsite(t.toLowerCase())}
            inputRef={textInputs.website}
            isInvalid={isInvalid.website}
            spellCheck={false}
            autoCapitalize='none'
            // onSubmitEditing={() => textInputs.newServiceArea.current.focus()}
            // returnKeyType='next'
            textContentType='URL'
            returnKeyType='next'
            keyboardType='url'
            value={props.website}
          />
        </View>
        {/* insurance */}
        {/* <View style={styles.marginContainer}>
          <Insurance
            {...props}
            textInputs={textInputs}
            isInvalid={isInvalid}
            setIsInvalid={setIsInvalid}
          />
        </View> */}
        {/* service areas */}
        <View style={styles.marginContainer}>
          <Text style={[CS.smallTitle, CS.lightText, styles.title]}>Service Areas</Text>
        {/* </View> */}
        {/* <View style={styles.marginContainer}>
          <Text style={[CS.smallText, CS.lightBlueText, styles.inputLabel]}>Location</Text>
        </View> */}
        <LocationPicker
          placeholder='Type a city'
          // value='Mississauga, ON'
          locations={props.serviceAreas}
          setLocations={props.setServiceAreas}
          streetId={props.contractorStreetId}
          offsetTop={Constants.statusBarHeight}
          // outerInputContainerStyle={styles.marginContainer}
          inputRef={textInputs.newServiceArea}
          setIsInvalid={setIsInvalidServiceArea}
          // initialSearch={initialLocation}
          afterSelectLocation={afterSelectLocation}
          setScrollEnabled={setScrollEnabled}
        />
        {/* <View style={styles.marginContainer}> */}
          <View style={styles.tags}>
            {props.serviceAreas.map((s) =>
              <Tag text={s.city + ', ' + s.state} key={s.id} remove={removeServiceArea} removeId={s.id} />
              // <Text>{s}</Text>
            )}
          </View>
        </View>

        {/* <View style={styles.marginContainer}>
          <Text style={[CS.smallTitle, CS.lightText, styles.title]}>Skills</Text>
          <TextInputContainer
            placeholder='Type a skill, comma separate to add multiple'
            onChangeText={(t) => setNewSkill(t)}
            inputRef={textInputs.newSkill}
            isInvalid={isInvalid.newSkill}
            spellCheck={true}
            onSubmitEditing={() => addSkill()}
            returnKeyType='next'
            returnKeyLabel='Add'
            value={newSkill}
          />
          <View style={styles.tags}>
            {props.skills.map((s) =>
              <Tag text={s} key={s} remove={removeSkill} removeId={s} />
            )}
          </View>
        </View> */}
        
        <View style={[styles.marginContainer, {marginBottom: 30}]}>
          <Button text='Continue' onPress={() => checkCompanyProfile} />
        </View>
      </KeyboardAwareScrollView>
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    width: '100%',
    flex: 1,
    marginBottom: 10,
  },
  innerContainer: {
    width: '100%',
    // backgroundColor: 'blue',
    maxWidth: Platform.OS === 'web' ? 768 : '100%',
    justifyContent: Platform.OS === 'web' ? 'center' : 'flex-start',
    flexGrow: 1,
    alignSelf: 'center',
  },
  safe: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
  },
  blurTest: {
    position: 'absolute',
    top: 10,
    left: 10,
    width: '100%',
    height: '100%',
    padding: 10,
    borderRadius: 10,
    zIndex: 4,
  },
  scrollView: {
    backgroundColor: Colors.blue,
    flex: 1,
  },
  // container: {
  //   flex: 1,
  //   width: '100%',
  //   height: '100%',
  //   // position: 'relative',
  //   // backgroundColor: 'pink',
  // },
  marginContainer: {
    marginHorizontal: 10,
  },
  logo: {
    // aspectRatio: 1024 / 675,
    // aspectRatio: 1440 / 1080,
    // aspectRatio: 1280 / 720,
    borderTopLeftRadius: 5,
    borderTopRightRadius: 5,
  },
  gradient: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    height: '100%',
  },
  buttonsOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    paddingHorizontal: 15,
    flexDirection: 'row',
    alignItems: 'center',
  },
  backArrow :{
    marginRight: 10,
  },
  pageTitle: {
    flex: 1,
    marginHorizontal: 10,
  },
  editButton: {
    marginLeft: 10,
    // marginRight: 15,
  },
  section: {
    marginBottom: 20,
  },
  gallery: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    // justifyContent: 'space-between',
    // flex: 1,
  },
  thumbContainer: {
    borderRadius: 5,
    flex: 1,
    flexBasis: '23.5%',
    flexGrow: 0,
    marginRight: '2%',
    marginBottom: '2%',
  },
  thumbContainerNoRightMargin: {
    borderRadius: 5,
    flex: 1,
    flexBasis: '23.5%',
    flexGrow: 0,
    marginRight: 0,
    marginBottom: '2%',
  },
  thumb: {
    aspectRatio: 150 / 150,
    borderRadius: 5,
  },
  title: {
    marginVertical: 10,
  },
  inputLabel: {
    marginBottom: 7,
  },
  bio: {
    height: 140,
    textAlignVertical: 'top',
  },
  photos: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginBottom:20,
  },
  newPhotoContainer: {
    backgroundColor: Colors.yellow,
    borderRadius: 10,
    alignItems: 'center',
    justifyContent: 'center'
  },
  photoPlus: {
    position: 'absolute',
  },
  // photoButtons: {
  //   // marginLeft: 'auto',
  //   flexDirection: 'row',
  // },
  // photoButton: {
  //   flexDirection: 'row',
  //   backgroundColor: Colors.yellow,
  //   padding: 5,
  //   borderRadius: 10,
  //   alignItems: 'center',
  // },
  // photoButtonText: {
  //   fontSize: 18,
  //   marginLeft: 5,
  // },
  tags: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
    marginTop: -5,
    marginBottom:10,
  },
});

export default React.memo(CompanyProfileScreen);